import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpService } from '@services/http.service';
import {
  SessionOrderCreateModel,
  SessionOrderModel,
} from '@models/session-order/session-order.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionOrderService {
  readonly #httpService = inject(HttpService);
  private readonly ordersUrl = `${environment.caisseApiUrl}/self-pos-terminal-session-orders`;

  getSessionOrders(sessionId: number): Observable<SessionOrderModel[]> {
    return this.#httpService
      .get<SessionOrderModel[]>(`${this.ordersUrl}/self-pos-terminal-session/${sessionId}`)
      .pipe(map((sessionOrders) => sessionOrders.map((order) => this.#withForcedStatus(order))));
  }

  getSessionOrder(orderId: number): Observable<SessionOrderModel> {
    return this.#httpService
      .get<SessionOrderModel>(`${this.ordersUrl}/${orderId}`)
      .pipe(map((sessionOrder) => this.#withForcedStatus(sessionOrder)));
  }

  createSessionOrder(sessionOrder: SessionOrderCreateModel): Observable<SessionOrderModel> {
    return this.#httpService
      .post<SessionOrderModel>(this.ordersUrl, sessionOrder)
      .pipe(map((order) => this.#withForcedStatus(order)));
  }

  #withForcedStatus(sessionOrder: SessionOrderModel): SessionOrderModel {
    if (!sessionOrder.forced_at) return sessionOrder;
    return { ...sessionOrder, order: { ...sessionOrder.order, status: 'forced' } };
  }
}
